import { de } from 'date-fns/locale/de'
import { enGB } from 'date-fns/locale/en-GB'

export const DATE_LOCALES = new Map([
  ['de', de],
  ['de_in', de],
])

export const DEFAULT_DATE_LOCALE = enGB

export const DEFAULT_TIME_ZONE = 'Europe/Vienna'

/**
 * Format is used in date pickers
 * @type {string}
 */
export const DATE_INPUT_FORMAT = 'dd/MM/yyyy'

/**
 * Regexp to match date value
 * @type {RegExp}
 */
export const DATE_INPUT_REGEXP = /^(\d{1,2})[.\-/\s](\d{1,2})[.\-/\s](\d{4})$/

/**
 * Format is used in time pickers
 * @type {string}
 */
export const TIME_INPUT_FORMAT = 'HH:mm'

/**
 * Regexp to match time value
 * @type {RegExp}
 */
export const TIME_INPUT_REGEXP = /^(\d{1,2})[:\s-](\d{2})$/

export const DATE_DEBUG_FORMAT = 'dd/MM/yyyy HH:mm:ss XXXXX'

export const DATE_SHORT_FORMAT = 'dd/MM/yyyy'

export const DATE_WEEKDAY_NAME_ABBR_FORMAT = 'EEE'

export const DATE_WEEKDAY_NAME_FORMAT = 'EEEE'

export const DATE_WEEKDAY_ABBR_FORMAT = `${DATE_WEEKDAY_NAME_ABBR_FORMAT} ${DATE_SHORT_FORMAT}`

export const DATE_LONG_FORMAT = 'dd MMMM yyyy'

export const DATE_WEEKDAY_SHORT_FORMAT = `${DATE_WEEKDAY_NAME_FORMAT}, ${DATE_SHORT_FORMAT}`

export const DATE_FULL_FORMAT = 'dd/MM/yyyy, HH:mm'

export const DATE_FULL_FORMAT_FROM_TIME = 'HH:mm, dd/MM/yyyy'

export const DATE_HOURS_FORMAT = 'HH:mm'

export const DATE_DAY_FORMAT = 'd'

export const DATE_MONTH_ABBR_FORMAT = 'MMM'

export const DATE_DAY_MONTH_SHORT_FORMAT = 'dd/MM'

export const DATE_DAY_MONTH_FORMAT = 'd MMMM'

export const DATE_DAY_MONTH_YEAR_FORMAT = 'd MMMM yyyy'

export const DATE_MONTH_YEAR_FORMAT = 'MMMM yyyy'

export const DATE_DAY_MONTH_YEAR_TIME_FORMAT = 'd MMMM yyyy, HH:mm'

export const DATE_FILTER_FORMAT = 'yyyy-MM-dd'

export const DATE_FILTER_FULL_FORMAT = 'yyyy-MM-dd HH:mm:ss'

export const DATE_API_DATA_FORMAT = 'yyyy-MM-dd HH:mm:ssXXX'

export const DATE_API_DATA_FORMAT_SHORT = 'yyyy-MM-dd'

export const RENTAL_PORTAL_DATE_API_SHORT_REGEXP = /^(\d{4})-(\d{2})-(\d{2})$/

export const DEADLINE_BG_COLOR_DEFAULT = 'var(--secondary-text-color-10)'

export const DEADLINE_TEXT_COLOR_DEFAULT = 'var(--main-text-color)'

export const DEADLINE_TEXT_COLOR_EARLY = 'var(--color-green)'

export const DEADLINE_TEXT_COLOR_OVERDUE = 'var(--color-red)'

export const DEADLINE_TEXT_COLOR_ROLLING = 'var(--color-orange)'

export const DATE_MASK_PLACEHOLDER = 'dd/mm/yyyy'

export const TIME_MASK_PLACEHOLDER = 'hh:mm'

export const MIN_YEAR = 1900

export const MAX_YEAR_OFFSET_FROM_NOW = 15

export const MAX_YEAR = new Date().getFullYear() + MAX_YEAR_OFFSET_FROM_NOW

export const SECOND_FIRST_MILLISECOND = 0

export const SECOND_LAST_MILLISECOND = 999

export const SECOND = SECOND_LAST_MILLISECOND - SECOND_FIRST_MILLISECOND + 1

export const MINUTE_FIRST_SECOND = 0

export const MINUTE_LAST_SECOND = 59

export const MINUTE_SECONDS = MINUTE_LAST_SECOND - MINUTE_FIRST_SECOND + 1

export const MINUTE = MINUTE_SECONDS * SECOND

export const HOUR_FIRST_MINUTE = 0

export const HOUR_LAST_MINUTE = 59

export const HOUR_MINUTES = HOUR_LAST_MINUTE - HOUR_FIRST_MINUTE + 1

export const HOUR_SECONDS = HOUR_MINUTES * MINUTE_SECONDS

export const HOUR = HOUR_SECONDS * SECOND

export const DAY_FIRST_HOUR = 0

export const DAY_LAST_HOUR = 23

export const DAY_HOURS = DAY_LAST_HOUR - DAY_FIRST_HOUR + 1

export const DAY_MINUTES = DAY_HOURS * HOUR_MINUTES

export const DAY_SECONDS = DAY_MINUTES * MINUTE_SECONDS

export const DAY = DAY_SECONDS * SECOND

export const WEEK_FIRST_DAY = 0

export const WEEK_LAST_DAY = 6

export const WEEK_DAYS = WEEK_LAST_DAY - WEEK_FIRST_DAY + 1

export const WEEK_HOURS = WEEK_DAYS * DAY_HOURS

export const WEEK_MINUTES = WEEK_HOURS * HOUR_MINUTES

export const WEEK_SECONDS = WEEK_MINUTES * MINUTE_SECONDS

export const WEEK = WEEK_SECONDS * SECOND

export const MONTH_FIRST_DAY = 1

export const YEAR_FIRST_MONTH = 0

export const YEAR_LAST_MONTH = 11

export const YEAR_MONTHS = YEAR_LAST_MONTH - YEAR_FIRST_MONTH + 1

export const YEAR_FIRST = 0

export const DATE_ROUNDING_METHOD = {
  CEIL: 'ceil',
  FLOOR: 'floor',
  ROUND: 'round',
  TRUNC: 'trunc',
}

/**
 * @type {import('date-fns').NearestMinutes}
 */
export const TIME_PICKER_STEP_MINUTES = 15

export const TIME_PICKER_STEP = TIME_PICKER_STEP_MINUTES * MINUTE

export const DATE_PICKER_YEAR_FUTURE_COUNT = 16
